<template>
	<div>
		<div class="text-center text-body-1 my-4 border pa-4" id="timerpayment" v-if="(parseInt(hours) > 0) && (parseInt(minutes) > 0) && (parseInt(seconds) > 0)">
			<div>Selesaikan pembayaran dalam</div>
			<div class="pt-2 text-h5 red--text font-weight-bold">
				<span> {{hours | two_digits}} </span> : <span> {{minutes | two_digits}} </span> : <span> {{seconds | two_digits}} </span>
			</div>
			<div class="pt-2 text-body-2 grey--text text--darken-1">Batas akhir pembayaran</div>
			<div class="pt-2 text-body-1 font-weight-bold">{{date | haritanggaljam }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		date: {
			type: String
		}
	},
	data() {
		return {
			now: Math.trunc((new Date()).getTime() / 1000)
		}
	},
	computed: {
		dateInMilliseconds() {
			return Math.trunc(Date.parse(this.date) / 1000)
		},
		seconds() {
			if(this.date){
				return (this.dateInMilliseconds - this.now) % 60;
			}
			else{
				return 59
			}
		},
		minutes() {
			if(this.date){
				return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
			}
			else{
				return 59
			}
		},
		hours() {
			if(this.date){
				return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60);
			}
			else{
				return 23
			}
			
			// return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
		},
		days() {
			return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
		}
	},
	mounted() {
		window.setInterval(() => {
			this.now = Math.trunc((new Date()).getTime() / 1000);
		}, 1000);
	},
}
</script>